import { ButtonOutline, Button } from 'rebass'
import Link from 'gatsby-link'
import React from 'react'
import styled from 'styled-components'

const StyledLink = styled(Link)`
  color: #3076c6;
  text-decoration: none;
  font-weight: bold;
  ${Button}:hover & {
    color: white;
  }
`

const ButtonLink = ({ to, title }) => (
  <ButtonOutline children={<StyledLink to={to}>{title}</StyledLink>} />
)

export default ButtonLink



// WEBPACK FOOTER //
// ./src/components/ButtonLink.js